module.exports = __webpack_public_path__ + "img/zain-jordan.c2b4cfed.svg";